import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="navbar">
      <div className="nav-inner">

        {/* BRAND */}
        <div className="brand">
          <div className="logo">STS</div>
          Smart Tech Solutions
        </div>

        {/* DESKTOP LINKS */}
        <nav className="nav-links">
          <Link to="/">Home</Link>
          <Link to="/services">Services</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
        </nav>

        {/* HAMBURGER (visible on mobile) */}
        <div className="hamburger" onClick={() => setOpen(!open)}>
          <div className={open ? "bar bar1 open" : "bar bar1"}></div>
          <div className={open ? "bar bar2 open" : "bar bar2"}></div>
          <div className={open ? "bar bar3 open" : "bar bar3"}></div>
        </div>

      </div>

      {/* MOBILE MENU DROPDOWN */}
      <div className={open ? "mobile-menu show" : "mobile-menu"}>
        <Link onClick={() => setOpen(false)} to="/">Home</Link>
        <Link onClick={() => setOpen(false)} to="/services">Services</Link>
        <Link onClick={() => setOpen(false)} to="/about">About</Link>
        <Link onClick={() => setOpen(false)} to="/contact">Contact</Link>
      </div>
    </header>
  );
}
